import { DRILL_TOPIC, HexElementProperties } from '~/types/drill'

const {
  BASIC_ALGEBRA_EN,
  BASIC_ALGEBRA_NB,
  BASIC_ALGEBRA_UA,
  EQUATIONS_EN,
  EQUATIONS_NB,
  EQUATIONS_UA,
  FACTORIZATION_EN,
  FACTORIZATION_NB,
  FACTORIZATION_UA,
  FRACTIONS_EN,
  FRACTIONS_NB,
  FRACTIONS_UA,
  FUNCTIONS_EN,
  FUNCTIONS_NB,
  FUNCTIONS_UA,
  PARENTHESES_EN,
  PARENTHESES_NB,
  PARENTHESES_UA,
  PERCENT_EN,
  PERCENT_NB,
  PERCENT_UA,
  POWERS_EN,
  POWERS_NB,
  POWERS_UA,
  THE_MULTIPLICATION_TABLE_EN,
  THE_MULTIPLICATION_TABLE_NB,
  THE_MULTIPLICATION_TABLE_UA,
} = DRILL_TOPIC

export const DRILL_TOPICS = {
  BASIC_ALGEBRA: [BASIC_ALGEBRA_EN, BASIC_ALGEBRA_NB, BASIC_ALGEBRA_UA],
  EQUATIONS: [EQUATIONS_EN, EQUATIONS_NB, EQUATIONS_UA],
  FACTORIZATION: [FACTORIZATION_EN, FACTORIZATION_NB, FACTORIZATION_UA],
  FRACTIONS: [FRACTIONS_EN, FRACTIONS_NB, FRACTIONS_UA],
  FUNCTIONS: [FUNCTIONS_EN, FUNCTIONS_NB, FUNCTIONS_UA],
  PARENTHESES: [PARENTHESES_EN, PARENTHESES_NB, PARENTHESES_UA],
  PERCENT: [PERCENT_EN, PERCENT_NB, PERCENT_UA],
  POWERS: [POWERS_EN, POWERS_NB, POWERS_UA],
  THE_MULTIPLICATION_TABLE: [THE_MULTIPLICATION_TABLE_EN, THE_MULTIPLICATION_TABLE_NB, THE_MULTIPLICATION_TABLE_UA],
}

export const DRILL_TOPIC_TITLES = Object.entries(DRILL_TOPICS).reduce(
  (acc, [key, value]) => ({ ...acc, [key]: value.map((entry) => entry.path) }),
  {},
)

export const TOPIC_HEXAGON_PROPERTIES: { [key in 'ACTIVITY' | 'DEFAULT' | 'SOLUTION']: HexElementProperties } = {
  ACTIVITY: {
    color: '#ffa841',
    i18nKey: 'playAlt',
    classNames: {
      button: 'bg-white text-xs',
      text: 'whitespace-nowrap font-bold text-lg text-black',
    },
  },
  DEFAULT: {
    color: 'white',
    i18nKey: 'go',
    classNames: {
      button: 'text-xs bg-orange-light',
      text: 'text-xs font-semibold text-hotpink',
    },
  },
  SOLUTION: {
    color: 'white',
    i18nKey: 'playAlt',
    classNames: {
      button: 'bg-white',
      text: 'whitespace-nowrap font-bold text-lg text-black',
    },
  },
}
